<template>
  <div>
    <el-breadcrumb separator-class="el-icon-arrow-right">
      <el-breadcrumb-item>租赁管理</el-breadcrumb-item>
      <el-breadcrumb-item>租金管理</el-breadcrumb-item>
    </el-breadcrumb>

    <el-form :inline="true" :model="formInline" class="user-search">
      <el-form-item label="搜索：">
        <el-input size="small" v-model="formInline.unitName" placeholder="输入单元名称"></el-input>
      </el-form-item>

      <el-form-item v-if="user.username == 'admin'" label="选择部门">
         <el-select v-model="formInline.departmentId" placeholder="请选择部门"  size="small">
            <el-option
              v-for="item in deptList"
              :key="item.id"
              :label="item.departmentName"
              :value="item.id">
            </el-option>
          </el-select>
      </el-form-item>
      <el-form-item  >
         <el-date-picker
            @change="getDay"
            type="daterange"

            size="small"
            value-format="yyyy-MM-dd"
            v-model="dayStr"
            range-separator="至"
            start-placeholder="开始日期"
            end-placeholder="结束日期"
            >
         </el-date-picker>
      </el-form-item>
      <el-form-item>
        <el-button size="small" type="primary" icon="el-icon-search" @click="search">搜索</el-button>
        <el-button size="small" type="primary" icon="el-icon-plus" @click="handelAdd">添加</el-button>
      </el-form-item>

    </el-form>

   <el-table  :header-cell-style="this.$store.state.headerCss" size="small" :data="dataList" highlight-current-row v-loading="loading" border element-loading-text="拼命加载中"
    style="width: 100%;"  stripe :max-height="tableHeight">
      <el-table-column align="center" type="index" width="60">
      </el-table-column>

      <el-table-column  prop="contractName" label="合同名称" show-overflow-tooltip>
      </el-table-column>
    	<el-table-column  prop="rent" label="租金" show-overflow-tooltip>
      </el-table-column>
      <el-table-column  prop="expensesFee" label="管理费" show-overflow-tooltip>
      </el-table-column>
      <el-table-column  prop="elevatorFee" label="电梯费" show-overflow-tooltip>
      </el-table-column>
      <el-table-column  prop="sanitationFee" label="卫生费" show-overflow-tooltip>
      </el-table-column>
      <el-table-column  prop="startTime" label="开始时间" show-overflow-tooltip>
      </el-table-column>
      <el-table-column  prop="endTime" label="结束时间" show-overflow-tooltip>
      </el-table-column>

     <el-table-column align="center" label="操作" width="180">
        <template slot-scope="scope">
          <prems-button size="mini"   perms="p:detail" @click="handleEdit(scope.row)" label="编辑" />
          <prems-button size="mini" type="danger"  perms="p:delete" @click="deleteInfo(scope.row)" label="删除" />

       <!--   <el-button size="mini" @click="handleEdit(scope.row)">编辑</el-button>
          <el-button size="mini" type="danger"    @click="deleteInfo(scope.row)">删除</el-button>
          <el-button size="mini" type="primary"   @click="handleRecharge(scope.$index, scope.row,'1')">充值</el-button>
          <el-button size="mini" type="warning"   @click="handleRecharge(scope.$index, scope.row,'2')">退款</el-button> -->
        </template>
      </el-table-column>
    </el-table>

    <!-- 分页组件 -->
    <Pagination v-bind:child-msg="formInline" @callFather="callFather" v-if="showPage"></Pagination>



    <el-dialog :title="title" :visible.sync="editFormVisible" width="35%" @click="editFormVisible = false">
    	<el-form label-width="120px" :model="editForm" :rules="rules" ref="editForm">
        <el-form-item v-if="user.username == 'admin'" label="选择部门">
           <el-select v-model="departmentId" placeholder="请选择部门"  size="small" @change="getContractList()">
              <el-option
                v-for="item in deptList"
                :key="item.id"
                :label="item.departmentName"
                :value="item.id">
              </el-option>
            </el-select>
        </el-form-item>

        <el-form-item  label="所属合同" prop="roomContractId">
           <el-select v-model="editForm.roomContractId" placeholder="请选择合同"  size="small">
              <el-option
                v-for="item in ContractList"
                :key="item.id"
                :label="item.contractName"
                :value="item.id">
              </el-option>
            </el-select>
        </el-form-item>
    		<el-form-item label="租金" prop="rent">
    			<el-input size="small" v-model="editForm.rent" auto-complete="off" placeholder="请输入租金"></el-input>
    		</el-form-item>
    		<el-form-item label="管理费">
    			<el-input size="small" v-model="editForm.expensesFee" type="number" auto-complete="off" placeholder="请输入管理费"></el-input>
    		</el-form-item>
       <el-form-item label="电梯费" >
        	<el-input size="small" v-model="editForm.elevatorFee" type="number" auto-complete="off" placeholder="请输入电梯费"></el-input>
        </el-form-item>

        <el-form-item label="卫生费" >
        	<el-input size="small" v-model="editForm.sanitationFee" type="number" auto-complete="off" placeholder="请输入卫生费"></el-input>
        </el-form-item>

      <el-form-item label="开始日期"  prop="startTime">
        	<el-date-picker
            v-model="editForm.startTime"
            type="date"
            size="small"
            value-format="yyyy-MM-dd"
            placeholder="开始日期">
          </el-date-picker>
        </el-form-item>
        <el-form-item label="结束日期" prop="endTime" >
        	<el-date-picker
            v-model="editForm.endTime"
            type="date"
            size="small"
            value-format="yyyy-MM-dd"
            placeholder="选择结束日期">
          </el-date-picker>
        </el-form-item>

    	</el-form>
    	<div slot="footer" class="dialog-footer">
    		<el-button size="small" @click="editFormVisible = false">取消</el-button>
    		<el-button size="small" type="primary" :loading="setLoading" class="title" @click="submitForm('editForm')">保存</el-button>
    	</div>
    </el-dialog>




  </div>
</template>

<script>
  import Pagination from '../../components/Pagination'
  import PremsButton from "@/views/permission/PreButtom";
  import { getDepartmentTerminalInfoLis } from '../../api/energyMG'
  import {
    findRoomContractList,
    roomRentAdd,
    getRoomRentList,
    roomRentDelete,
    roomRentUpdate
  } from '../../api/payMG.js'

  export default {
    data() {


      return {
        formInline: {
          pageSize:10,
          currentPage:1,
          total:0,
          roomContractId:"",
          startTime:'',
          departmentId:"",
          endTime:'',
        },
        saveLoad:false,
        totalFee:"",
        users:[],
        editForm:{
          rent : '',
          roomContractId:"",
          expensesFee : '',
          elevatorFee : '',
          sanitationFee : '',
          startTime : '',
          endTime : '',
          departmentId:""

        },
        pageparm:{

        },
        rtitle:"",
        rechargeFormVisible:false,
        setLoading:false,
        tableHeight:0,
        title:"",
        loading:false,
        meterPointName:"",
        editFormVisible:false,
        dataList:[],
        deptList:[],
        user:{},
        showPage:true,
        reditForm: {
        	totalFee:"",
        	appletUserId:'',
          roomId:"",
        	mark:"",
          roomType:"63",
          payType:'2',
        },
        dayStr:[],

        money:{
          water:'',
          wuYe:"",
        },

        rules: {
        	rent: [{required: true,message: '请输入租金',trigger: 'blur'}],
          roomContractId: [{required: true,message: '请选择合同',trigger: 'change'}],
          startTime: [{required: true,message: '开始时间不能为空',trigger: 'change'}],
          endTime: [{required: true,message: '结束时间不能为空',trigger: 'change'}],

        	// roomNum:[{validator:validatePass,trigger:'change' }]

        },

        ContractList:[],
      }
    },
    mounted(){
      this.$nextTick(() => {
      	this.tableHeight = window.innerHeight - 300
      })
    },
    created(){
      this.user = JSON.parse(sessionStorage.getItem('userdata'))
      this.departmentId = JSON.parse(sessionStorage.getItem('userdata')).departmentId
      if(this.user.username != 'admin'){
         this.formInline.departmentId = JSON.parse(sessionStorage.getItem('userdata')).departmentId
         this.editForm.departmentId = JSON.parse(sessionStorage.getItem('userdata')).departmentId
      }

      this.getData()
      this.getJzData()
      this.getContractList()







    },
    components: {
      Pagination,
      PremsButton
    },
    methods:{
      getDay(e){
        this.formInline.startTime = e[0]
        this.formInline.endTime = e[1]
        this.getData()

      },

      getJzData:function(){
      	return new Promise((resolve,reject) => {
      		getDepartmentTerminalInfoLis().then(res => {
      			this.treeLoad = false
      			if(res.status == 1){
      				let arr = []
      				this.deptList = res.data.menuDepList

      			}
      			else{
      				this.$message.error(res.msg)
      			}
      		})
      	})

      },



      getContractList(){
        let param = {
          depId:this.departmentId,
          contractName:"",
          roomName:"",
          contractor:"",
          pageSize:9999,
          currentPage:1,
        }
        findRoomContractList(param).then(res => {
          if(res.status == 1){
            this.ContractList = res.data.data
          }else{
            this.$message.error(res.msg)
          }
        })
      },

      changeType(e){
        if(this.reditForm.roomType == '63'){
          this.dForm.blance = this.money.water
        }else{
           this.dForm.blance = this.money.wuYe
        }
      },


      getData(){
        this.loading = true
        getRoomRentList(this.formInline).then(res => {
          this.loading = false
          if(res.status == 1){
            this.dataList = res.data.data
            this.formInline.total = res.data.totalCount

          }else{
            this.$message.error(res.msg)
          }
        })
      },
      handelAdd(){
        this.editFormVisible = true
        this.title = '添加'
        this.editForm.id = ''
        this.editForm.rent = ''
        this.editForm.expensesFee = ''
        this.editForm.elevatorFee = ''
        this.editForm.sanitationFee = ''
        this.editForm.startTime =  ''
        this.editForm.endTime =  ''
        this.editForm.roomContractId = ''


      },

      handleEdit(row){
        this.title = '编辑'

        this.editFormVisible = true
        this.editForm.id = row.id
        this.editForm.rent = row.rent
        this.editForm.expensesFee = row.expensesFee
        this.editForm.elevatorFee = row.elevatorFee
        this.editForm.sanitationFee = row.sanitationFee
        this.editForm.startTime =  row.startTime
        this.editForm.endTime =  row.endTime
        this.departmentId = row.departmentId
        this.editForm.roomContractId = row.roomContractId


        this.getContractList()


      },
      search(){
        this.getData()
      },
      callFather(parm){
        this.formInline.currentPage = parm.currentPage
        this.formInline.pageSize = parm.pageSize
        this.getData()
      },

      deleteInfo(row){
        this.$confirm('确定要删除吗?', '信息', {
        		confirmButtonText: '确定',
        		cancelButtonText: '取消',
        		type: 'warning'
        	})
        	.then(() => {
        		// 删除
        		roomRentDelete({
        				id: row.id,

        			})
        			.then(res => {
        				if (res.status == 1) {
        					this.$message({
        						type: 'success',
        						message: '已删除!'
        					})
        					this.getData()
        				} else {
        					this.$message({
        						type: 'info',
        						message: res.msg
        					})
        				}
        			})
        			.catch(err => {
        				this.loading = false
        				this.$message.error('删除失败，请稍后再试！')
        			})
        	})
        	.catch(() => {
        		this.$message({
        			type: 'info',
        			message: '已取消删除！'
        		})
        	})
      },
      getMeterInfoList() {
      	this.loadMeter = true
      	let param = {
      		meterPointName: this.meterPointName,
      		energyType:15,
      		priceConfigId:this.curPriceId
      	}
      	findAllMeterInfoList(param).then(res => {
      		this.loadMeter = false
      		if (res.status == 1) {
      			this.MeterInfoList = res.data
      			//this.setChoisMeter(row)
      		} else {
      			this.$message({
      				type: 'info',
      				message: res.msg
      			})
      		}
      	})
      	.catch(err => {
      		this.loadMeter = false
      		this.$message.error('获取数据失败，请稍后再试！')
      	})
      },

      submitForm(){

        this.$refs['editForm'].validate(valid => {

        	if(valid){
            if(this.title == '添加'){
              this.add()
            }else{
              this.update()
            }
          }
        })


      },

      add(){
       this.setLoading = true
        roomRentAdd(this.editForm).then(res => {
           this.setLoading = false
          if(res.status == 1){
            this.editFormVisible = false
            this.$message.success("操作成功")
            this.getData();
          }else {
            this.$message.error(res.msg)
          }
        })
      },
      update(){
         this.setLoading = true
        roomRentUpdate(this.editForm).then(res => {
           this.setLoading = false
          if(res.status == 1){
            this.editFormVisible = false
            this.$message.success("操作成功")
            this.getData();
          }else {
            this.$message.error(res.msg)
          }
        })
      }
    }
  }
</script>

<style>
</style>



// WEBPACK FOOTER //
// src/views/property/rent.vue